module.exports = __webpack_public_path__ + "img/pin-master.88b066aa.png";